// extracted by mini-css-extract-plugin
module.exports = {"projects-panel":"MainPage__projects-panel__3lcNA","projects-header":"MainPage__projects-header__1Edej"};